
import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import AllCustomer from "../components/allCustomer.jsx";
import Footer from "../components/footer.jsx";

function AllCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < AllCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default AllCustomerPage;
